<script>
import VueChartJs from 'vue-chartjs'

export default {
  name: 'BarChart',
  extends: VueChartJs.Bar,
  mixins: [VueChartJs.mixins.reactiveProp],
  data () {
    return {
      legendHtml: null
    }
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    genLegend: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    options: {
      handler (val) {
        if (this.genLegend && !this.legendHtml) {
          this.legendHtml = this.$data._chart.generateLegend()
        }

        // Handle reactivity on options values
        this.$data._chart.destroy()
        this.renderChart(this.chartData, this.options)
      },
      deep: true
    }
  },
  render: function (createElement) {
    return createElement(
      'div', {
        class: 'chart-wrapper'
      },
      [
        createElement(
          'div', {
            style: this.styles,
            class: this.cssClasses
          },
          [
            createElement(
              'canvas', {
                attrs: {
                  id: this.chartId,
                  width: this.width,
                  height: this.height
                },
                ref: 'canvas'
              }
            )
          ]
        ),
        createElement(
          'div', {
            attrs: {
              id: this.chartId + '-legend',
              class: 'chart-legend'
            },
            domProps: {
              innerHTML: this.legendHtml
            }
          }
        )
      ]
    )
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/BarChart.vue